import * as yup from "yup";

import { fetchData } from "@utils/api";
import { APIMethods, ApiResponse } from "@typeDefinitions";
import {
  ClinicBillingDataResourceNew,
  clinicBillingDataResourceNewSchema,
} from "@client/resources/ClinicBillingDataResourceNew";
import { logFetchValidateError } from "@utils/validate";

export type FetchClinicBillingDataNewResponse =
  ApiResponse<ClinicBillingDataResourceNew>;

export const fetchClinicBillingDataNew =
  async (): Promise<FetchClinicBillingDataNewResponse> => {
    const response = await fetchData(
      "/dietitian/clinic/billing-data-new",
      APIMethods.GET,
    );
    return await responseSchema
      .validate(response)
      .catch(logFetchValidateError("/dietitian/clinic/billing-data-new"));
  };

const responseSchema = yup.object({
  data: clinicBillingDataResourceNewSchema.required(),
});
